export const SET_CURRENT_THEME = 'SET_CURRENT_THEME';
